import React from "react";
import { useSelector } from "react-redux";
import { RadioGroup, Radio, createStyles } from "@mantine/core";

const useStyles = createStyles((theme, { colors }) => ({
  answerWrap: {
    marginTop: 10,
  },
  answerStyle: {
    color: colors.default_text_color,
    fontSize: 16
  },
  radioStyle: {
    "&:checked": {
      backgroundColor: colors.primary_button_background_color,
      borderColor: colors.primary_button_background_color
    },
  }
}));

export default function SurveySelectInput({ options, selectedOptions, onChange }) {
  const colors = useSelector((state) => state.colors);

  const { classes } = useStyles({ colors });

  const _options = Array.isArray(options?.values) ? options.values : [];
  const _selectedOptions = Array.isArray(selectedOptions) ? selectedOptions : [];

  const onChangeSelect = (newValue) => {
    if (typeof onChange === "function") {
      onChange([newValue]);
    }
  };

  return (
    <RadioGroup
      value={_selectedOptions.length ? _selectedOptions[0] : null}
      onChange={onChangeSelect}
      orientation="vertical"
      styles={{
        root: classes.answerWrap,
        label: classes.answerStyle,
        radio: classes.radioStyle,
      }}
    >
      {_options.map((option, key) => {
        return <Radio key={key} value={option.value} label={option.name} />;
      })}
    </RadioGroup>
  );
}